import { action } from 'typesafe-actions';
import { MapStyleControllerActionTypes } from './types';

export const getBaseMapsStart = (basemaps: any[]) =>
  action(MapStyleControllerActionTypes.GET_BASE_MAPS_START, { basemaps });
export const getBaseMapsSuccess = (payload: any) =>
  action(MapStyleControllerActionTypes.GET_BASE_MAPS_SUCCESS, payload);
export const getBaseMapsFailure = (payload: string) =>
  action(MapStyleControllerActionTypes.GET_BASE_MAPS_FAILURE, payload);
